import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';


const SocialLogin = ({ onSocialLogin, isLoading }) => {
  const [loadingProvider, setLoadingProvider] = useState(null);

  const socialProviders = [
    {
      id: 'google',
      name: 'Google',
      icon: 'Chrome',
      bgColor: 'bg-white',
      textColor: 'text-gray-700',
      borderColor: 'border-gray-300',
      hoverBg: 'hover:bg-gray-50'
    },
    {
      id: 'facebook',
      name: 'Facebook',
      icon: 'Facebook',
      bgColor: 'bg-blue-600',
      textColor: 'text-white',
      borderColor: 'border-blue-600',
      hoverBg: 'hover:bg-blue-700'
    },
    {
      id: 'apple',
      name: 'Apple',
      icon: 'Apple',
      bgColor: 'bg-black',
      textColor: 'text-white',
      borderColor: 'border-black',
      hoverBg: 'hover:bg-gray-800'
    }
  ];

  const handleSocialLogin = async (provider) => {
    setLoadingProvider(provider.id);
    
    try {
      // Simulate API call
      await new Promise(resolve => setTimeout(resolve, 1500));
      
      // Mock successful social login
      const mockUser = {
        id: Date.now(),
        name: `${provider.name} User`,
        email: `user@${provider.id}.com`,
        provider: provider.id,
        avatar: `https://ui-avatars.com/api/?name=${provider.name}+User&background=random`
      };
      
      onSocialLogin(mockUser);
    } catch (error) {
      console.error(`${provider.name} login failed:`, error);
    } finally {
      setLoadingProvider(null);
    }
  };

  return (
   <></>
  );
};

export default SocialLogin;